import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { PaymentMethod } from '@/model-types/invoice';
import MoneyField from "@/components/MoneyField.vue";
let Payments = class Payments extends Vue {
    value;
    total;
    balance;
    inDebt;
    payments = [];
    emitInput(payments) {
        return payments;
    }
    valueWatcher(value) {
        this.payments = value;
    }
    paymentsWatcher(payments) {
        this.emitInput(payments);
    }
    totalWatcher() {
        if (this.inDebt)
            this.payments = [];
        else
            this.recalculatePayments();
    }
    inDebtWatcher(state) {
        if (state)
            this.payments = [];
        else
            this.recalculatePayments();
    }
    get paymentMethods() {
        let methods = [
            { text: this.$t('Cash'), value: PaymentMethod.cash },
            { text: this.$t('Card'), value: PaymentMethod.card },
            { text: this.$t('By guarantee'), value: PaymentMethod.guarantee },
            { text: this.$t('Mobile payment'), value: PaymentMethod.mobile },
            { text: this.$t('Other'), value: PaymentMethod.other },
        ];
        if (this.balance > 0)
            methods.push({ text: this.$t('userBalance'), value: PaymentMethod.userBalance });
        return methods;
    }
    get unusedMethods() {
        let usedPaymentMethods = this.value.map((el) => el.paymentMethod);
        return this.paymentMethods.filter((el) => !usedPaymentMethods.includes(el.value));
    }
    get paymentsSum() {
        return this.payments.reduce((total, item) => total + item.toPay, 0);
    }
    setToPay(index, value) {
        if (this.payments[index].paymentMethod === PaymentMethod.userBalance)
            return;
        this.payments[index].toPay = value;
    }
    readonly(payment) {
        return payment.paymentMethod === PaymentMethod.userBalance;
    }
    selectOptions(except) {
        let result = this.unusedMethods.concat(this.paymentMethods.filter(el => el.value === except));
        return this.$sortArrayByArray(result, this.paymentMethods, (sortArrEl, arrEl) => sortArrEl.value === arrEl.value);
    }
    recalculatePayments() {
        let fromBalance = 0;
        let result = [];
        if (this.balance > 0) {
            fromBalance = Math.min(this.balance, this.total);
            result.push({ paymentMethod: PaymentMethod.userBalance, toPay: fromBalance });
        }
        if (fromBalance < this.total)
            result.push({ paymentMethod: this.paymentMethods[0].value, toPay: this.total - fromBalance });
        this.payments = result;
    }
    addPayment() {
        let remainingSum = this.total - this.paymentsSum;
        this.payments.push({ paymentMethod: this.unusedMethods[0].value, toPay: remainingSum });
    }
    remove(index) {
        let amountRemoved = this.payments[index].toPay;
        this.payments.splice(index, 1);
        this.setToPay(index - 1, this.payments[index - 1].toPay + amountRemoved);
    }
};
__decorate([
    Prop({ type: Array })
], Payments.prototype, "value", void 0);
__decorate([
    Prop({})
], Payments.prototype, "total", void 0);
__decorate([
    Prop({})
], Payments.prototype, "balance", void 0);
__decorate([
    Prop({ type: Boolean })
], Payments.prototype, "inDebt", void 0);
__decorate([
    Emit('input')
], Payments.prototype, "emitInput", null);
__decorate([
    Watch('value', { deep: true })
], Payments.prototype, "valueWatcher", null);
__decorate([
    Watch('payments', { deep: true })
], Payments.prototype, "paymentsWatcher", null);
__decorate([
    Watch('total')
], Payments.prototype, "totalWatcher", null);
__decorate([
    Watch('inDebt')
], Payments.prototype, "inDebtWatcher", null);
Payments = __decorate([
    Component({
        components: {
            MoneyField,
        }
    })
], Payments);
export default Payments;
